import { render, staticRenderFns } from "./DelayOrder.vue?vue&type=template&id=6da1206f&scoped=true"
import script from "./DelayOrder.vue?vue&type=script&lang=js"
export * from "./DelayOrder.vue?vue&type=script&lang=js"
import style0 from "./DelayOrder.vue?vue&type=style&index=0&id=6da1206f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1206f",
  null
  
)

export default component.exports